import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';

function createNetworkInterface({ uri, opts, links }) {
  return ApolloLink.from([
    ...(links || []),
    createHttpLink({
      uri,
      ...opts,
    }),
  ]);
}

export default createNetworkInterface;
